<div class="side-panel-count-container">
  <h5>{{ 'fence.materials.side-panel-count-title' | translate }}</h5>
  @for (side of sides; track side.id) {
    <p>
      {{ 'fence.materials.side' | translate }} {{ side.id }} : {{ getCompletePanelBySide(side) }}
      {{ 'fence.preview.panels' | translate }}
    </p>
  }
</div>
